"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceFacts = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var MetaConverter_1 = require("../../../convertors/fromBackend/MetaConverter");
var api_1 = require("../../../utils/api");
var BearWorkspaceFacts = /** @class */ (function () {
    function BearWorkspaceFacts(authCall, workspace) {
        this.authCall = authCall;
        this.workspace = workspace;
    }
    BearWorkspaceFacts.prototype.getFactDatasetMeta = function (ref) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, objectId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(ref, this.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        objectId = api_1.getObjectIdFromUri(uri);
                        return [2 /*return*/, this.authCall(function (sdk) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var usedBy;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, sdk.xhr.getParsed("/gdc/md/" + this.workspace + "/usedby2/" + objectId + "?types=dataSet")];
                                        case 1:
                                            usedBy = _a.sent();
                                            ts_invariant_1.default(usedBy.entries.length > 0, "Fact must have a dataset associated to it.");
                                            return [2 /*return*/, MetaConverter_1.convertMetadataObjectXrefEntry("dataSet", usedBy.entries[0])];
                                    }
                                });
                            }); })];
                }
            });
        });
    };
    return BearWorkspaceFacts;
}());
exports.BearWorkspaceFacts = BearWorkspaceFacts;
//# sourceMappingURL=index.js.map